// This type comes from @recurly/recurly-js, but it is not correctly defined there so we have to redefine it here.
// In their code they have it wrapped in a `pricing` object, but that is not the case in the actual response.
export type SubscriptionPricingState = {
  now: {
    subtotal: string
    plan: string
    addons: string
    setup_fee: string
    discount: string
    tax: string
    total: string
  }
  base: {
    plan: {
      setup_fee: string
      unit: string
    }
  }
  next: {
    subtotal: string
    plan: string
    addons: string
    setup_fee: string
    discount: string
    tax: string
    total: string
  }
  currency: {
    code: string
    symbol: string
  }
}

// we'll use these defaults instead of applying loading states and blocking the UI until the plans load
export const defaultAnnualPrice: SubscriptionPricingState = {
  now: {
    subtotal: '119.99',
    plan: '119.99',
    discount: '0.00',
    total: '119.99',
    addons: '0.00',
    setup_fee: '0.00',
    tax: '0.00',
  },
  base: {
    plan: {
      setup_fee: '0.00',
      unit: '119.99',
    },
  },
  next: {
    subtotal: '119.99',
    plan: '119.99',
    discount: '0.00',
    total: '119.99',
    addons: '0.00',
    setup_fee: '0.00',
    tax: '0.00',
  },
  currency: { code: 'USD', symbol: '$' },
}

export const defaultMonthlyPrice: SubscriptionPricingState = {
  now: {
    subtotal: '24.99',
    plan: '24.99',
    discount: '0.00',
    total: '24.99',
    addons: '0.00',
    setup_fee: '0.00',
    tax: '0.00',
  },
  base: {
    plan: {
      setup_fee: '0.00',
      unit: '24.99',
    },
  },
  next: {
    subtotal: '24.99',
    plan: '24.99',
    discount: '0.00',
    total: '24.99',
    addons: '0.00',
    setup_fee: '0.00',
    tax: '0.00',
  },
  currency: { code: 'USD', symbol: '$' },
}
